"use client";

import { SORT_OPTIONS, type SortKey } from "../../lifestyle-constants";
import BottomSheet from "../BottomSheet";
import { RadioIcon } from "../lifestyleIcons";

interface SortSheetProps {
  isOpen: boolean;
  selected: SortKey;
  onSelect: (sort: SortKey) => void;
  onClose: () => void;
}

/**
 * Mobile presentation of the Sort by menu. Desktop keeps the inline dropdown in
 * FilterDropdown; picking here is a single choice, so the rows are radios.
 */
export default function SortSheet({ isOpen, selected, onSelect, onClose }: SortSheetProps) {
  return (
    <BottomSheet isOpen={isOpen} title="Sort by" showCloseButton onClose={onClose}>
      <div role="radiogroup" aria-label="Sort by" className="flex flex-col w-full">
        {SORT_OPTIONS.map(option => {
          const isSelected = option.key === selected;

          return (
            <button
              key={option.key}
              type="button"
              role="radio"
              aria-checked={isSelected}
              onClick={() => {
                onSelect(option.key);
                onClose();
              }}
              className="flex items-center w-full min-h-11 py-[11px] gap-2 font-roboto text-base text-left leading-5.5 text-dark-1">
              <RadioIcon
                isSelected={isSelected}
                className={`shrink-0 size-6 transition-colors ${isSelected ? "text-primary" : "text-gray-5"}`}
              />
              <span className="flex-1 min-w-0 break-words">{option.label}</span>
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
}
